<template lang="pug">
  div.picker-wrapper(ref="picker")
    div(data-test="colorPickerTrigger" v-if="transientColor")
      v-layout.align-center(ref="pickerParent")
        svg.ma-2(width="24" height="24")
          rect.border_ColorPicker(width="24" height="24" :fill="transientColor")
        span.subheading(data-test="pickerLiteralColor") {{ transientColor }}
</template>

<script>
import Picker from 'vanilla-picker';

export default {
  props: {
    color: String,
    popup: String,
  },
  data() {
    return {
      transientColor: this.color,
      pos: this.popup || 'right',
    };
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line no-unused-vars
      const instance = this;
      // eslint-disable-next-line no-unused-vars
      const picker = new Picker({
        parent: this.$refs.pickerParent,
        alpha: false,
        popup: this.pos,
        color: this.transientColor,
        onDone: this.changeColor,
      });
    });
  },
  watch: {
    color(newColor) {
      this.transientColor = newColor;
    },
  },
  methods: {
    changeColor(color) {
      this.transientColor = color.hex.substring(0, 7);
      if (color !== this.transientColor) {
        this.$emit('changeColor', this.transientColor);
      }
    },
  },
};
</script>


<style scoped lang="scss">
  .picker_wrapper.popup {
    z-index: 450!important;
  }
  .border_ColorPicker{
    stroke: #A1A1A1;
  }
  svg {
    border-radius: 4px;
  }
</style>
